import React, { FC, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { PATHS } from 'src/routes/paths';

import { ButtonGroup } from '@/shared/ui/Button';

const Segments = [
    { text: 'Lend', value: PATHS.HOME },
    { text: 'Borrow', value: PATHS.BORROW },
];

interface SegmentButtonGroupProps {
    list?: { text: string; value: string }[];
    handleSegmentChanged?: (value: string | number) => void;
    initialValue?: string | number;
}

export const SegmentButtonGroup: FC<SegmentButtonGroupProps> = ({
    list = Segments,
    handleSegmentChanged,
    initialValue,
}) => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState<string | number>(initialValue || pathname);

    const handleChange = (newValue: string | number) => {
        if (handleSegmentChanged) {
            handleSegmentChanged(newValue);
        }
        setActiveTab(newValue);
        if (pathname !== newValue) {
            navigate(newValue.toString());
        }
    };

    return (
        <div className='mt-8 flex items-center justify-center mb-10'>
            <ButtonGroup
                className='w-72'
                btnClassName='font-semibold'
                items={list}
                value={activeTab}
                handleChange={handleChange}
            />
        </div>
    );
};
